module.exports = __webpack_public_path__ + "img/voucher-icon.8418af5c.svg";